export default __webpack_public_path__ + "static/about-pinbar-banner-c521ab87d3835e26ada428f25985509a.png";